import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesPersonalizedNutrientProfileAction';
import fetchApi from "./fetchApi";

function fetchFeedingGuidelinesPersonalizedNutrientProfileAction(products, amounts) {
  const productsString = JSON.stringify(products);
  const amountsString = JSON.stringify(amounts);
  return fetchApi(`/v1/fc_api/feeding_guidelines_personalized_nutrient_profile_resource?products=${productsString}&weights=${amountsString}`, fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesPersonalizedNutrientProfileAction;
